var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgChronometer(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#105C6E"
    },
    d: "M149.944,101.607l-29.896-29.958c-6.935-6.949-16.16-10.775-25.977-10.775 c-9.817,0-19.042,3.827-25.976,10.775L46.424,93.367c-14.265,14.293-14.265,37.551,0,51.845l29.959,30.021 c2.93,2.936,6.773,4.404,10.618,4.404c3.833,0,7.668-1.461,10.596-4.382c5.864-5.852,46.47-46.591,52.326-52.435 C155.786,116.969,155.796,107.472,149.944,101.607z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#26879C"
    },
    d: "M256,3c-8.284,0-15,6.716-15,15v48c0,8.284,6.716,15,15,15c8.284,0,15-6.716,15-15V18 C271,9.716,264.284,3,256,3z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#DE513C"
    },
    d: "M293,0h-74c-8.284,0-15,6.716-15,15s6.716,15,15,15h74c8.284,0,15-6.716,15-15S301.284,0,293,0z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FC6249"
    },
    d: "M256,0h-37c-8.284,0-15,6.716-15,15s6.716,15,15,15h37V0z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#DE513C"
    },
    d: "M418.645,118.615C375.203,75.083,317.441,51.108,256,51.108S136.797,75.083,93.355,118.615 c-43.434,43.524-67.354,101.391-67.354,162.939s23.92,119.415,67.354,162.939C136.797,488.025,194.559,512,256,512 s119.203-23.975,162.645-67.507c43.434-43.524,67.354-101.391,67.354-162.939S462.079,162.139,418.645,118.615z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FC6249"
    },
    d: "M256,51.108c-61.441,0-119.203,23.975-162.645,67.507c-43.434,43.524-67.354,101.391-67.354,162.939 s23.92,119.415,67.354,162.939C136.797,488.025,194.559,512,256,512V51.108z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96D1D9"
    },
    d: "M256,108.538c-95.218,0-172.684,77.614-172.684,173.015S160.782,454.569,256,454.569 s172.684-77.615,172.684-173.016S351.218,108.538,256,108.538z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F4F2E6"
    },
    d: "M256,108.538c-95.218,0-172.684,77.614-172.684,173.015S160.782,454.569,256,454.569V108.538z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#105C6E"
    },
    d: "M256,146.007c8.284,0,15-6.716,15-15v-21.808c-4.945-0.428-9.946-0.66-15-0.66 c-5.054,0-10.055,0.232-15,0.66v21.808C241,139.291,247.716,146.007,256,146.007z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#105C6E"
    },
    d: "M256,417.101c-8.284,0-15,6.716-15,15v21.808c4.945,0.428,9.946,0.66,15,0.66 c5.054,0,10.055-0.232,15-0.66v-21.808C271,423.817,264.284,417.101,256,417.101z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#105C6E"
    },
    d: "M428.028,266.554h-21.481c-8.284,0-15,6.716-15,15s6.716,15,15,15h21.481 c0.426-4.945,0.656-9.946,0.656-15S428.454,271.499,428.028,266.554z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#105C6E"
    },
    d: "M120.453,281.554c0-8.284-6.716-15-15-15H83.972c-0.426,4.945-0.656,9.946-0.656,15 s0.23,10.055,0.656,15h21.481C113.737,296.554,120.453,289.838,120.453,281.554z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#105C6E"
    },
    d: "M293,272.897h-21.162V212.23c0-8.284-6.716-15-15-15c-8.284,0-15,6.716-15,15v75.667 c0,8.284,6.716,15,15,15H293c8.284,0,15-6.716,15-15S301.284,272.897,293,272.897z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgChronometer);
export default __webpack_public_path__ + "static/media/chronometer.81b300b2.svg";
export { ForwardRef as ReactComponent };